"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Overview_1 = __importDefault(require("./Overview"));
const Developer_1 = __importDefault(require("./Developer"));
const Layout_1 = require("./Layout");
const Account = () => (react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Layout_1.Layout, null), path: '*' },
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Overview_1.default, null), path: 'overview' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Developer_1.default, null), path: 'developer' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_router_dom_1.Navigate, { to: 'overview' }), index: true }))));
exports.default = Account;
